import { postWithAuth } from '@/api/httpRequests'
import { getConfigRoute } from '@/api/toya/apiConstantsCodespot'
import Config from '../../../../shared/config/config'

export const getApiConfigToya = async () => {
    const apiConfig = await postWithAuth(getConfigRoute)
    if (apiConfig) return new Config(apiConfig)

    return null
}
